/**
 * Here we are exporting node type values globally
 */
export const nodeOptions: any = [
  { value: "KPI", label: "KPI", symbol: "diamond" },
  { value: "Metric", label: "Metric", symbol: "rectangle" },
  { value: "DataPoint", label: "DataPoint", symbol: "oval" },
  { value: "Category", label: "Category", symbol: "triangle" },
];
